import { useBlockProps, InnerBlocks } from "@wordpress/block-editor";

export default function save({ attributes }) {
	const { url, opensInNewTab } = attributes;
	const blockProps = useBlockProps.save();

	if (!url) {
		return (
			<div {...blockProps}>
				<InnerBlocks.Content />
			</div>
		);
	}

	return (
		<a
			{...blockProps}
			href={url}
			target={opensInNewTab ? "_blank" : undefined}
			rel={opensInNewTab ? "noopener noreferrer" : undefined}
		>
			<InnerBlocks.Content />
		</a>
	);
}
